// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as SelectPromotionChain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ApplyPromotion";
import { xGoogleAnalyticsState } from "@stoneage/App/Store/Reducers/xGoogleAnalytics";
import { getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";

export const TrackGaSelectPromotion: typeof PopulateApiParameter = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.selectPromotionEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }
        const cart = getCurrentCartState(props.getState()).value;
        const { apiResult } = props;
        if (apiResult) {
            const googleAnalyticsData = {
                event: "select_promotion",
                promotion_id: apiResult.id,
                promotion_name: apiResult.name,
                items: cart?.cartLines?.map(cartLine => ({
                    item_name: cartLine.shortDescription,
                    item_id: cartLine.erpNumber,
                    price: cartLine.pricing?.unitNetPrice,
                    quantity: cartLine.qtyOrdered,
                    item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
                    item_category: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["category"] || ""
                        : undefined,
                    item_list_id: state.xGoogleAnalytics.includeProductCategory
                        ? cartLine.properties?.["categoryId"] || ""
                        : undefined,
                })),
                impersonation: trackAsImpersonation(state),
            };

            dataLayer.push(googleAnalyticsData);
        }
    }
};

addToEndOfChain(SelectPromotionChain, TrackGaSelectPromotion);
